import baseService from '../shared/baseService';

const contentClientService = (clientId: number) => baseService(`clients/${clientId}/contents`);

export default { 
    contentClientService
};

